<template>
    <div class="pageConfig">
        <!-- 会员主题设置 -->
        <headConfig v-if="pageConfig.menberPage.configState == 0"></headConfig>
        <!-- 会员权益设置 -->
        <powerConfig v-show="pageConfig.menberPage.configState == 1"></powerConfig>
        <!-- 热门互动配置 -->
        <hotConfig v-show="pageConfig.menberPage.configState == 2"></hotConfig>
        <!-- 兑换精选配置 -->
        <exchangeConfig v-show="pageConfig.menberPage.configState == 3"></exchangeConfig>
        <!-- 隐藏间隙 configState=0 为false  头部不显示间隙 -->
        <div class="hideGaps" v-show="pageConfig.menberPage.configState">
            <!-- <el-checkbox v-model="pageHideGaps">隐藏该模块下方的背景色间隙</el-checkbox> -->
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import headConfig from './headConfig'
import powerConfig from './powerConfig'
import hotConfig from './hotConfig'
import exchangeConfig from './exchangeConfig'

export default {
    components: {
        headConfig,
        powerConfig,
        hotConfig,
        exchangeConfig
    },
    computed: {
        ...mapState(["pageConfig"]),
        pageHideGaps: {
            get() {
                return this.$store.state.pageConfig.menberPage.pageHideGaps
            },
            set(v) {
                this.hideGapsChange(v)
            }
        }
    },
    data() {
        return {
        }
    },
    methods: {
        ...mapMutations([
            "hideGapsChange"
        ]),
    }
}
</script>

<style lang="scss" scoped>
.pageConfig {
    box-sizing: border-box;
    height: 100%;
}
</style>
